"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/List/RoomsList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');
var _reactwaypoint = require('react-waypoint');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');
var _helpers = require('web/components/VideoRooms/Room/History/helpers');

var _MeetingsFilter = require('web/components/VideoRooms/List/MeetingsFilter'); var _MeetingsFilter2 = _interopRequireDefault(_MeetingsFilter);
var _List = require('web/components/VideoRooms/List'); var _List2 = _interopRequireDefault(_List);
var _SectionHeader = require('web/components/VideoRooms/List/SectionHeader'); var _SectionHeader2 = _interopRequireDefault(_SectionHeader);












// Was an instance field set in the constructor; its identity never changed.
const filterMenuOptions = [
  { label: 'Active meetings', value: 'active' },
  { label: 'Archived meetings', value: 'archived' },
]

const handleArchiving = (RoomKey) => _actions2.default.archiveVideoRoom({ RoomKey })
const handleUnarchiving = (RoomKey) => _actions2.default.unarchiveVideoRoom({ RoomKey })

// memo keeps the PureComponent / connect() bailout on unchanged props.
const RoomsList = _react.memo.call(void 0, function RoomsList ({
  gotoRoom, currentRoomKey,
}) {
  // The selector builds a new array on every call; shallowEqual keeps the
  // previous one while its rooms are unchanged.
  const roomsList = _hooks.useAppSelector.call(void 0, _videoRoom.selectRelevantRoomsList, _reactredux.shallowEqual)
  const currentSearchContext = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentSearchContext)

  // The class read `this.props` when loading; this ref holds the committed
  // props. It is declared before useClassState so that it is current when
  // that hook flushes setState callbacks in its own layout effect.
  const latestProps = _react.useRef.call(void 0, { roomsList, currentSearchContext })
  _react.useLayoutEffect.call(void 0, () => {
    latestProps.current = { roomsList, currentSearchContext }
  })

  const [state, setState, latestState] = _helpers.useClassState(() => ({
    // SAFETY: the module constant above has two options.
    currentFilter: filterMenuOptions[0].value,
    searchQuery: '',
  }))
  const { currentFilter, searchQuery } = state

  const searchTimeout = _react.useRef(undefined)

  // Stable, like the class method, so the Waypoint's onEnter never changes.
  const loadVideoRooms = _react.useCallback.call(void 0, () => {
    const committedState = latestState.current
    const committedProps = latestProps.current

    const areArchived = committedState.currentFilter === 'archived'

    const {
      areArchived: prevAreArchived,
      query: prevSearchQuery,
    } = committedProps.currentSearchContext

    const loadedVideoRoomsCount = committedProps.roomsList.length

    const shouldAppend =
      areArchived === prevAreArchived && prevSearchQuery === committedState.searchQuery

    clearTimeout(searchTimeout.current)
    _actions2.default.loadVideoRooms({
      Archived: areArchived,
      Query: committedState.searchQuery,
      Skip: shouldAppend ? loadedVideoRoomsCount : 0,
      Take: 10,
    })
  }, [latestState])

  const handleFilterUpdate = _react.useCallback.call(void 0, (f) => setState(
    { currentFilter: f }, loadVideoRooms,
  ), [setState, loadVideoRooms])

  const handleSearchQueryUpdate = _react.useCallback.call(void 0, (q) => {
    clearTimeout(searchTimeout.current)
    setState({ searchQuery: q }, () => {
      searchTimeout.current = setTimeout(loadVideoRooms, 500)
    })
  }, [setState, loadVideoRooms])

  // componentDidMount (class timing). As in the class, nothing clears a
  // pending search timeout on unmount.
  _react.useLayoutEffect.call(void 0, () => { loadVideoRooms() }, [loadVideoRooms])

  const shouldRenderWaypoint =
    roomsList.length > 0 && !currentSearchContext.hasDrained

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_MeetingsFilter2.default, {
        searchQuery: searchQuery,
        onSearchQueryUpdate: handleSearchQueryUpdate,
        currentFilter: currentFilter,
        filterMenuOptions: filterMenuOptions,
        onFilterUpdate: handleFilterUpdate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
      )
      , _react2.default.createElement(_SectionHeader2.default, {
        label: currentFilter === 'archived'
          ? 'Archived meetings'
          : 'Active meetings'
        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
      )
      , _react2.default.createElement(_List2.default, {
        gotoRoom: gotoRoom,
        onArchive: handleArchiving,
        onUnarchive: handleUnarchiving,
        roomsList: roomsList,
        currentRoomKey: currentRoomKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
      )
      ,  shouldRenderWaypoint &&
        _react2.default.createElement(_reactwaypoint.Waypoint, {
          key: roomsList.length,
          onEnter: loadVideoRooms, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        )
      
    )
  )
})

exports. default = RoomsList
